import { addAlpha, getColorForString } from '../../pages/utils';
import { Patient, getPtFullName, getPtFullNameWithSalutation } from '../../store/types/patient';
import { getAgeString } from '../../store/utils';

export function getAgeStr(pt: Patient) {
    const age = getAgeString({
        age: pt.personal.age?.value,
        month: pt.personal.age?.month,
        dob: pt.personal.age?.dob,
    });
    if (age === '') return '';
    else return `${age}`;
}

export const PtListItemViewOnlyContent: React.FC<{
    pt: Patient;
    className: string;
}> = ({ pt, className }) => {
    const uhid = pt.formData?.find((i) => i.key === 'uhid')?.value;
    const trimmedUhid = typeof uhid === 'string' ? uhid.trim() : uhid;
    const {
        personal: { phone },
    } = pt;
    const phoneNumber = phone?.c && phone.n ? `${phone.c}${phone.n}` : '';
    const formattedPatientDetails = [trimmedUhid && `#${trimmedUhid}`, phoneNumber]
        .filter(Boolean)
        .join(' | ');
    return formattedPatientDetails ? (
        <div className={`truncate-overflow-1 flex gap-8 ${className}`}>
            {formattedPatientDetails}
        </div>
    ) : null;
};

export const PtListItemViewOnly: React.FC<{ pt: Patient }> = (props) => {
    const { pt } = props;
    const ptNameText = getPtFullName(pt);
    const color = getColorForString(ptNameText);
    const gender = pt.personal.gender?.[0]?.toUpperCase();
    const age = pt.personal.age && getAgeStr(pt);
    const formattedPatientDetails = [gender, age].filter(Boolean).join(' | ');
    return (
        <button className="flex items-start space-x-8 text-14 text-darwin-neutrals-1000">
            <span
                style={{ color: color, backgroundColor: addAlpha(color, 0.1) }}
                className="rounded-full w-24 h-24 min-w-24 min-h-24 text-12 font-700 flex items-center justify-center"
            >
                <span>
                    {pt.personal.name.f && pt.personal.name.f[0]}
                    {pt.personal.name.l && pt.personal.name.l[0]}
                </span>
            </span>
            <span className="truncate-overflow-1 relative top-2 text-left">
                <span className="font-700 break-words">
                    <span>{getPtFullNameWithSalutation(pt)}</span>{' '}
                    {pt.archived && <span>(Archived)</span>}
                    {formattedPatientDetails && ` | ${formattedPatientDetails}`}
                </span>
            </span>
        </button>
    );
};
